import LabServiceCollection from "@/collections/LabServiceCollection";
import ProjectStatusLogModel from "@/models/lab/ProjectStatusLogModel";

export default class ProjectStatusLogCollection extends LabServiceCollection {
  model() {
    return ProjectStatusLogModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddDesc('created_at');
    
    return CollectionFilter;
  }

}
